// Isomorphic helper. SSR reads the better-auth session cookie presence
// from the incoming request so the header auth slot renders the correct
// shape (avatar skeleton when present, Sign-In otherwise) without an API
// hop. The SSR value is serialized into router context and reused at
// hydration; subsequent client navigations preserve it.
//
// `createIsomorphicFn` keeps the `getCookie` server call out of the
// client bundle so this module can be imported from __root.tsx without
// tripping the import-protection plugin.
import { createIsomorphicFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";

const SESSION_COOKIE_NAME = "majourneys.session_token";
// better-auth prefixes the cookie with `__Secure-` on https deployments.
const SECURE_SESSION_COOKIE_NAME = `__Secure-${SESSION_COOKIE_NAME}`;

export const readSessionHintFromRequest = createIsomorphicFn()
  .client(() => false)
  .server(() => {
    try {
      return Boolean(getCookie(SECURE_SESSION_COOKIE_NAME) ?? getCookie(SESSION_COOKIE_NAME));
    } catch {
      return false;
    }
  });
